import { Link } from "react-router-dom";
import { ArrowRight, Ship } from "lucide-react";
import { FadeUp } from "./Reveal";

export default function Global() {
  return (
    <section id="export" data-testid="export-section" className="bg-navy py-20 text-white md:py-32">
      <div className="mx-auto max-w-7xl px-5 md:px-10">
        <FadeUp className="max-w-3xl">
          <p className="text-xs font-semibold uppercase tracking-[0.28em] text-gold">
            Export & Global Supply
          </p>
          <h2 className="mt-4 font-display text-3xl font-semibold leading-[1.08] tracking-tight md:text-5xl">
            From India to International Markets
          </h2>
          <p className="mt-6 max-w-2xl text-base leading-relaxed text-white/70">
            RBL EXIM is focused on serving international customers with
            carefully sourced Indian food products, reliable supply and
            coordinated shipment support.
          </p>
        </FadeUp>

        <FadeUp delay={0.12}>
          <div
            data-testid="export-route-graphic"
            className="mt-16 flex flex-col items-stretch gap-6 rounded-2xl border border-white/10 bg-navy-soft p-8 md:flex-row md:items-center md:gap-0 md:p-12"
          >
            <div className="flex-1 text-center md:text-left">
              <p className="text-xs font-semibold uppercase tracking-[0.24em] text-gold">Origin</p>
              <p className="mt-2 font-display text-2xl font-semibold tracking-tight md:text-3xl">
                India
              </p>
              <p className="mt-1 text-sm text-white/60">Rajkot, Gujarat</p>
            </div>

            <div className="relative flex flex-1 items-center justify-center py-2" aria-hidden="true">
              <span className="h-px w-full border-t-2 border-dashed border-gold/50" />
              <span className="absolute flex h-12 w-12 items-center justify-center rounded-full bg-gold text-navy">
                <Ship size={22} />
              </span>
            </div>

            <div className="flex-1 text-center md:text-right">
              <p className="text-xs font-semibold uppercase tracking-[0.24em] text-gold">Destination</p>
              <p className="mt-2 font-display text-2xl font-semibold tracking-tight md:text-3xl">
                Global Markets
              </p>
              <p className="mt-1 text-sm text-white/60">Confirmed per buyer requirement</p>
            </div>
          </div>
        </FadeUp>

        <FadeUp delay={0.2}>
          <div className="mt-12 flex flex-wrap gap-4">
            <Link
              to="/#enquire"
              data-testid="export-quote-button"
              className="group inline-flex items-center gap-3 rounded-full bg-gold px-8 py-4 text-sm font-semibold uppercase tracking-[0.12em] text-navy transition-colors duration-300 hover:bg-white"
            >
              Request a Quote
              <ArrowRight size={17} className="transition-transform duration-300 group-hover:translate-x-1" />
            </Link>
            <Link
              to="/catalogue"
              data-testid="export-catalogue-button"
              className="inline-flex items-center rounded-full border border-white/30 px-8 py-4 text-sm font-semibold uppercase tracking-[0.12em] text-white transition-colors duration-300 hover:border-white hover:bg-white/10"
            >
              Explore Products
            </Link>
          </div>
        </FadeUp>
      </div>
    </section>
  );
}
